import { hasLaunchDatePassed } from "@/utils/date-constants";
import CheckItem from "@/components/cayman/CheckItem";

interface WhyCaymanSectionProps {
  formattedLaunchDate: string;
}

const WhyCaymanSection = ({ formattedLaunchDate }: WhyCaymanSectionProps) => {
  const launchPassed = hasLaunchDatePassed();

  return (
    <section className="py-20 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Why NationCard™ for{" "}
              <span className="text-nation-purple">Cayman Islands</span>
            </h2>

            <p className="text-lg mb-6">
              NationCard™ is specifically tailored for the unique political and
              social landscape of the Cayman Islands. We understand the issues
              that matter to Caymanians.
            </p>

            <ul className="space-y-4">
              <CheckItem>
                Focused on Caymanian issues like sustainable tourism, financial
                services, and environmental protection
              </CheckItem>
              <CheckItem>
                Local team with deep understanding of Cayman's political
                structure and culture
              </CheckItem>
              <CheckItem>
                Privacy-focused design with data stored in compliance with
                Cayman Islands data protection laws
              </CheckItem>
              <CheckItem>
                Customized for Cayman's unique multi-member constituency system
              </CheckItem>
            </ul>
          </div>

          <div className="relative">
            <img
              src="/img/nationcard-choose-informed.png"
              alt="NationCard™ Platform Preview"
              className="rounded-lg shadow-xl"
            />
            <div className="absolute -bottom-6 -right-6 bg-white dark:bg-gray-800 p-4 rounded-lg shadow-lg border border-gray-100 dark:border-gray-700">
              <div className="flex items-center gap-3">
                <div className="h-12 w-12 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold">
                  KY
                </div>
                <div>
                  <p className="font-semibold">Cayman Islands</p>
                  <p className="text-sm text-muted-foreground">
                    {launchPassed
                      ? "Now Live!"
                      : `Coming ${formattedLaunchDate}`}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyCaymanSection;
